import React, { useState, useEffect, Children } from "react";
import * as componentIcons from "assets/svgComponents";

import styles from "./navigation.module.css";
import Text from "Components/shared/text";
import { NavItem } from "Components/navigation";
import { Link } from "react-router-dom";
import { icons } from "assets";

const SideBar = () => {
  const list = [
    {
      image: <componentIcons.Home />,
      link: "Dashboard",
      route: "/",
      //   path: "/your-drive/appointment",
    },
    {
      image: <componentIcons.Wallet />,
      link: "Wallet",
      route: "/wallet",
      // path: "/your-drive/consultations",
    },
    {
      image: <componentIcons.Debit />,
      link: "Debit Card",
      route: "/debit-card",
      // path: "/your-drive/medical-records",
    },
    {
      image: <componentIcons.Transfer />,
      link: "International Transfer",
      route: "/transfer",
      // path: "/your-drive/medical-records",
    },
    {
      image: <componentIcons.History />,
      link: "Transaction History",
      route: "/transaction-history",
      // path: "/your-drive/medical-records",
    },
    {
      image: <componentIcons.Account />,
      link: "Account",
      route: "/account",
      // path: "/your-drive/medical-records",
    },
  ];

  return (
    <div>
      <div className="general" style={{ paddingLeft: "27px" }}>
        <Link to="/">
          <img src={icons.logo2} alt="company logo" />
        </Link>
      </div>
      <div className={styles.Nav}>
        {list.map((item, index) => (
          <NavItem
            key={index}
            to={item.route}
            label={item.link}
            icon={item.image}
          />
        ))}
      </div>
      <div className={styles.Logout}>
        <Link to="/logout">
          <span className={styles.icon}>
            <componentIcons.Logout />
          </span>
          <Text tag="span" style={{ marginLeft: "20px", marginBottom: "3px", color: "#64748B" }}>
            Logout
          </Text>
        </Link>
      </div>
    </div>
  );
};

export default SideBar;
